import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {
	// 2021-11-11
	findByOrderId(orderId) {
		return axios.get('/weddingDressHall/quality/find-by-order-id/' + orderId);
	},

}